const sections = {
  active: cached_elements.get_node( 'section.active' ),
  main: cached_elements.get_node( `#main-container` ).setAttribute( 'data-active', cached_elements.get_node( 'section.active' ).getAttribute( 'data-section' ) ),
  tc: 'Terms & Conditions',
  news: 'XYZ News',
  ecommerce: 'Sahara',
  social: 'Chirpr',
  hub: 'Hub'
}

/**
 * @function open_section - closes the current section and opens the requested section
 * @param {String} section - section to open
 */
const open_section = ( section ) =>
{

  const selected_section = cached_elements.get_node( `[data-section="${section}"]` );
  const main = cached_elements.get_node( `#main-container` );

  if ( selected_section !== sections.active )
  {
    prepare_section( main, section, selected_section );
    check_if_first_visit_to_news_section( section );
    start_social_timer((section === 'social'));
    init_tc_timer((section === 'hub'));
    sections.active = selected_section;
    main.setAttribute('class', 'main-container section-' + section);
    let yearCountup = new CountUp('header__title--year', 2029, {startVal: 2019, useGrouping: false});
    let yearCountup2 = new CountUp('header__title--year-2', 2029, {startVal: 2019, useGrouping: false});
    yearCountup.start();
    yearCountup2.start();
  }
}


const prepare_section = ( main, section, selected_section ) =>
{
  main.setAttribute( 'data-active', section );
  selected_section.classList.add( 'active' );
  sections.active.classList.remove( 'active' );
  window.scrollTo( 0, 0 );
}


const check_if_first_visit_to_news_section = ( section ) =>
{
  if ( section === 'news' && !visitedNewsSection )
  {
    setTimeout( function()
    {
      popupContinue();
    }, 500 );
  }
}